const assetsURL = import.meta.env.VITE_ASSETS_URL;

export const Loading = <div className="fixed inset-0 z-50 grid w-screen h-screen p-4 bg-white place-items-center sm:p-6 lg:p-8 opacity-30">
  <img className="w-auto h-16" src={assetsURL + "loader.svg"} alt="" />

</div>